module.exports = __webpack_public_path__ + "img/doorLogo39.b843dc4f.png";